module.exports = __webpack_public_path__ + "static/media/top_shape_3_mob.4e61dd4f.svg";